'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.doFormatGender = exports.doFormatUpper = exports.doFormatLower = exports.doFormatTitle = exports.doFormatYesNo = exports.doFormatShortDate = exports.doFormat = void 0, exports.formatSys2MomentDate = formatSys2MomentDate, exports.formatMoment2SysDate = formatMoment2SysDate, exports.formatSys2ShortDate = formatSys2ShortDate, exports.formatSys2ShortDateYear = formatSys2ShortDateYear, exports.formatSys2OdooDate = formatSys2OdooDate, exports.formatOdooDate2Sys = formatOdooDate2Sys, exports.formatOdooDatetime2Sys = formatOdooDatetime2Sys, exports.formatSys2OdooDatetime = formatSys2OdooDatetime;

var _monthnames = require('./monthnames.json'),
    _monthnames2 = _interopRequireDefault(_monthnames),
    _choice_lists = require('./choice_lists.js');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var pad = function pad(a) {
  return 9 >= a ? '0' + a : a;
}; // return full month name given month number 1-12


function monthname(a) {
  try {
    return _monthnames2.default['' + parseInt(a)];
  } catch (a) {
    return 'X';
  }
} // date(Dec 31, 2019 23:01:59) => 20191231230159


function formatSys2MomentDate(a) {
  var b = a.getDate(),
      c = a.getMonth() + 1,
      d = a.getFullYear(),
      e = a.getSeconds(),
      f = a.getMinutes(),
      g = a.getHours(); //Month from 0 to 11

  return '' + d + pad(c) + pad(b) + pad(g) + pad(f) + pad(e);
} // 20191231230159 => date(Dec 31, 2019 23:01:59)


function formatMoment2SysDate(a) {
  var b = new Date();
  return b.setFullYear(parseInt(a.substr(0, 4))), b.setMonth(parseInt(a.substr(4, 2)) - 1), b.setDate(parseInt(a.substr(6, 2))), b.setHours(parseInt(a.substr(8, 2))), b.setMinutes(parseInt(a.substr(10, 2))), b.setSeconds(parseInt(a.substr(12, 2))), b;
} // date(Dec 31, 2019 23:01:59) => Dec 31, 2019 or Dec 31 if current year is 2019


function formatSys2ShortDate(a) {
  var b = a.getDate(),
      c = a.getMonth() + 1,
      d = a.getFullYear(); //Month from 0 to 11

  return monthname(c).substr(0, 3) + ' ' + pad(b) + (d === new Date().getFullYear() ? '' : ', ' + d);
}

function formatSys2ShortDateYear(a) {
  var b = a.getDate(),
      c = a.getMonth() + 1,
      d = a.getFullYear(); //Month from 0 to 11

  return monthname(c).substr(0, 3) + ' ' + pad(b) + (', ' + d);
} // date(Dec 31, 2019 23:01:59) => str(2019-12-31)


function formatSys2OdooDate(a) {
  try {
    var b = a.getDate(),
        c = a.getMonth() + 1,
        d = a.getFullYear(); //Month from 0 to 11

    return d + '-' + pad(c) + '-' + pad(b);
  } catch (a) {
    return null;
  }
} // str(2019-12-31) => date(Dec 31, 2019 23:01:59)


function formatOdooDate2Sys(a) {
  if (a !== void 0 && null !== a && '' !== a && !1 !== a) try {
    var b = a.substring(0, 10).split('-');
    return new Date(parseInt(b[0]), parseInt(b[1]) - 1, parseInt(b[2]));
  } catch (a) {}
  return '';
} // str(2019-12-31) => str(Dec 31, 2019) or str(Dec 31) if current year is 2019


function formatOdooDate2Short(a) {
  if (a !== void 0 && null !== a && '' !== a && !1 !== a) try {
    var b = a.substring(0, 10).split('-');
    return monthname(b[1]).substr(0, 3) + ' ' + b[2] + (b[0] === new Date().getFullYear() ? '' : ', ' + b[0]);
  } catch (a) {}
  return 'Invalid Date';
}

function formatOdooDate2ShortYear(a) {
  if (a !== void 0 && null !== a && '' !== a && !1 !== a) try {
    var b = a.substring(0, 10).split('-');
    return monthname(b[1]).substr(0, 3) + ' ' + b[2] + (', ' + b[0]);
  } catch (a) {}
  return 'Invalid Date';
} // str(2019-12-31) => str(Dec 2019)


function formatOdooDate2Month(a) {
  if (a !== void 0 && null !== a && '' !== a && !1 !== a) try {
    var b = a.substring(0, 10).split('-');
    return monthname(b[1]).substr(0, 3) + ' ' + b[0];
  } catch (a) {}
  return 'Invalid Date';
} // str(2020-12-12T23:59:00.000Z) => Date("12/13/2020, 5:29:00 AM") in IST


function formatOdooDatetime2Sys(a) {
  if (a !== void 0 && null !== a && '' !== a && !1 !== a) try {
    return new Date(a);
  } catch (a) {}
  return '';
} // Date("12/13/2020, 5:29:00 AM") in Browser IST => str(2020-12-12T23:59:00.000Z)


function formatSys2OdooDatetime(a) {
  try {
    return a.toISOString();
  } catch (a) {
    return null;
  }
} // ANdhra PRADESH => Andhra Pradesh


var toTitleCase = function toTitleCase(a) {
  var b, c, d, e, f;

  for (d = a.replace(/([^\W_]+[^\s-]*) */g, function (a) {
    return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
  }), e = ['A', 'An', 'The', 'And', 'But', 'Or', 'For', 'Nor', 'As', 'At', 'By', 'For', 'From', 'In', 'Into', 'Near', 'Of', 'On', 'Onto', 'To', 'With'], (b = 0, c = e.length); b < c; b++) {
    d = d.replace(new RegExp('\\s' + e[b] + '\\s', 'g'), function (a) {
      return a.toLowerCase();
    });
  } // Certain words such as initialisms or acronyms should be left uppercase


  for (f = ['Id', 'Tv'], b = 0, c = f.length; b < c; b++) {
    d = d.replace(new RegExp('\\b' + f[b] + '\\b', 'g'), f[b].toUpperCase());
  }

  return d;
},
    get = function get(a, b, c) {
  try {
    return a[b];
  } catch (a) {
    return c;
  }
},
    doFormat = exports.doFormat = function (a, b) {
  if ('string' != typeof a) return b;

  switch (a) {
    case 'firebaseobject':
      if (!!b) try {
        var c = JSON.parse(b);
        return c.fileName;
      } catch (a) {
        return '-not available-';
      } else return '-not uploaded';

    case 'datetimeiso':
      return new Date(b).toISOString();

    case 'datelocale':
      return new Date(b).toLocaleDateString();

    case 'datetimelocale':
      return new Date(b).toLocaleString();

    case 'timelocale':
      return new Date(b).toLocaleTimeString();

    case 'shortdate':
      return formatOdooDate2Short(b);

    case 'shortdateyear':
      return formatOdooDate2ShortYear(b);

    case 'monthyear':
      return formatOdooDate2Month(b);

    case 'yesno':
      return b ? 'yes' : 'no';

    case 'gender':
      return get({
        F: 'Female',
        M: 'Male'
      }, b, 'Not Mentioned');

    case 'variant':
      return get({
        A: 'A/c',
        N: 'Non A/c'
      }, b, 'Not Available');

    case 'age_group':
      return get({
        0: '00-04 Children',
        5: '05-09 Children',
        10: '10-14 Children',
        15: '15-19 Youth',
        20: '20-24 Youth',
        25: '25-29 Youth',
        30: '30-34 Youth',
        35: '35-39 Adults',
        40: '40-44 Adults',
        45: '45-49 Adults',
        50: '50-55 Adults',
        55: '55-59 Adults',
        60: '60-64 Seniors',
        65: '65-69 Seniors',
        70: '70-74 Seniors',
        75: '75-79 Seniors',
        80: '80-85 Seniors',
        85: '85+ Seniors',
        90: '90+ Seniors'
      }, b.toString(), 'Not Specified');

    case 'idcard_type':
      return get({
        srcmid: 'SRCM / Heartfulness ID',
        aadhar: 'Aadhar',
        passport: 'Passport',
        drvlic: 'Other ID Cards',
        child: 'Children',
        heartfulnessid: 'Heartfulness ID',
        otherid: 'Other ID Cards'
      }, b, b);

    case 'arrival_time':
      return get(_choice_lists.arrival_time_opts, b, '');

    case 'departure_time':
      return get(_choice_lists.departure_time_opts, b, '');

    default:
      return b;
  }
},
    doFormatShortDate = exports.doFormatShortDate = function (a) {
  return doFormat('shortdate', a);
},
    doFormatYesNo = exports.doFormatYesNo = function (a) {
  return doFormat('yesno', a);
},
    doFormatTitle = exports.doFormatTitle = function (a) {
  try {
    return toTitleCase(a);
  } catch (b) {
    return a;
  }
},
    doFormatLower = exports.doFormatLower = function (a) {
  try {
    return a.toLowerCase();
  } catch (b) {
    return a;
  }
},
    doFormatUpper = exports.doFormatUpper = function (a) {
  try {
    return a.toUpperCase();
  } catch (b) {
    return a;
  }
},
    doFormatGender = exports.doFormatGender = function (a) {
  return doFormat('gender', a);
}; // formatFROM2TO - formats a given value in FROM to TO
// doFormat formats a given string to the required type
// doFormatTO - formats a given string to TO type